<mat-accordion [ngStyle]="applyDesign()">

  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>

      <mat-panel-title>

        <div class="question-title-section">

          <span class="title-style">{{ title }}</span>
          <span class="is-mandatory" style="color: #ff8282"></span>

        </div>

      </mat-panel-title>

      <mat-panel-description>

        <button class="add-edit-button">

          <img *ngIf="isAddingOrEditing === 'adding'" (click)="executeFunction()" src="assets/icons/add_button.svg">
          <img *ngIf="isAddingOrEditing === 'editing'" (click)="executeFunction()" src="assets/icons/edit-button.svg">
        </button>

      </mat-panel-description>

    </mat-expansion-panel-header>

    <div class="chips-rectangle-design">

      <div *ngFor="let item of arrayItems">

        {{ item.answer }}

        <!-- <mat-chip-set *ngFor="let subItem of item.allergyTypes" style="display: flex;">
          <mat-chip style="display: flex;">

            {{ subItem.answer }}

            <button class="add-edit-button">
              <img src="assets/icons/chip_close.svg">
            </button>

          </mat-chip>
        </mat-chip-set> -->

      </div>
    </div>

  </mat-expansion-panel>
</mat-accordion>
